module.controller(
    'clientListCtrl',
    [ '$scope', '$rootScope', '$state', 'clientService', 'alertService', 
        function($scope, $rootScope, $state, clientService, alertService) {

            $scope.filter = {
                visible: true
            };
            $scope.clients = [];
            $scope.pagination = {
                current : 1,
                total : 0
            };

            /**
             *
             * @param page
             */
            $scope.search = function(page) {
                $scope.loading = true;

                page = page == undefined ? 1 : page;
                $scope.pagination.current = page;

                var filter = {};
                filter.offset = (page - 1) * $rootScope.pageSize;
                filter.limit = $rootScope.pageSize;
                filter.visible = $scope.filter.visible;

                if($scope.filter.name){
                    filter.name = $scope.filter.name;
                }

                clientService.searchClients(filter).then(function(response) {
                    $scope.loading = false;
                    var result = response.getData();

                    $scope.clients = result.results;
                    $scope.pagination.total = result.totalRegisters;

                }, function(response) {
                    $scope.loading = false;
                });
            };

            $scope.remove= function(idClient){
            	var cli = $scope.clients.find(function(cli){ return cli.id == idClient; })
                alertService.showSwtWarningQuestion('Eliminar el cliente "'+ cli.name +'"', function() {
                    $scope.loading = true;

                    clientService.removeClient(idClient).then(function(response) {
                        $scope.loading = false;
                        $scope.search(1);
                        alertService.showSuccess('Cliente eliminado satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            }
            
            /**
             *
             */
            $scope.clearFilters = function(){
                $scope.filter = {};
            };

            $scope.search(1);
            
            $scope.changeClientState = function(client){
            	
            	var	idClient = client.id;	
        		var	state = client.active;
            	
            	if(state){
            		clientService.enableClient(idClient).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess('Cliente activo nuevamente en el sistema');
            		}, function(response) {
            			$scope.loading = false;	
            			client.active = false;
            		}); 
            	}
            	else{
            		clientService.disableClient(idClient).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess('Cliente inactivo');
            		}, function(response) {
            			$scope.loading = false;	
            			client.active = true;
            		}); 
            	}
            };

        } ]);
